<div class="pt-3">
    <!-- Filtros -->
    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
        <div class="row search-area">
            <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                    <mat-label>Pesquisar Regra</mat-label>
                    <input matInput type="text" formControlName="pesquisa" placeholder="Nome ou observação da regra...">
                    <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div class="col-12 col-lg-6 filter-container">
                <button #filtrosMenuTrigger="matMenuTrigger" mat-stroked-button type="button"
                    class="btn-filter" [matMenuTriggerFor]="filtroMenu"
                    [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
                    <mat-icon>filter_list</mat-icon>
                    Filtrar
                </button>

                <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                    <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
                        <h6>Filtros</h6>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Modelo Documento</mat-label>
                            <mat-select formControlName="modeloDocumento">
                                <mat-option [value]="null">Todos</mat-option>
                                @for (modelo of modelosDocumento; track modelo.codigo) {
                                <mat-option [value]="modelo.codigo">{{ modelo.nome }} - {{ modelo.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <app-select-pesquisavel 
                            label="Natureza de Operação"
                            [control]="getControl('naturezaOperacao')"
                            [apiUrl]="naturezaOperacaoLookupUrl"
                            idField="id"
                            nameField="descricao"
                            [hideLabel]="false"
                            [isOptional]="true"
                            placeholder="Todas">
                        </app-select-pesquisavel>
                        
                        <div class="filter-menu__actions">
                            <button mat-button class="btn-secondary" matMenuClose
                                (click)="filtrosMenuTrigger.closeMenu()">Cancelar</button>
                            <button mat-flat-button class="btn-primary" matMenuClose
                                (click)="aplicarFiltros()">Aplicar</button>
                        </div>
                    </div>
                </mat-menu>

                <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                    <mat-icon>cleaning_services</mat-icon>
                    Limpar Filtros
                </button>
            </div>
        </div>

    </form>

    @if (_isLoading && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_dataSource.data.length > 0) {

    <!-- Tabela desktop -->
    <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>

        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="w-checkbox">
                <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
            <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
        </ng-container>

        <ng-container matColumnDef="modelos">
            <th mat-header-cell *matHeaderCellDef>Modelos de Documento</th>
            <td mat-cell *matCellDef="let element">
                <div class="badges-row d-flex flex-wrap gap-1">
                    @for (mod of element.modelosDocumento; track $index) {
                        <span class="status-badge badge-laranja">{{ getNomeModeloDocumento(mod) }}</span>
                    }
                    @if (element.modelosDocumento.length === 0) {
                        <span class="text-secondary" style="font-size:0.82rem;">—</span>
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="cst">
            <th mat-header-cell *matHeaderCellDef>CST IBS/CBS</th>
            <td mat-cell *matCellDef="let element">
                <span class="status-badge badge-azul" style="font-weight: 500;">{{element.cst}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="cclassTrib">
            <th mat-header-cell *matHeaderCellDef>Cód. Classificação Trib. IBS/CBS</th>
            <td mat-cell *matCellDef="let element">
                <span class="status-badge badge-roxo" style="font-weight: 500;">{{element.cclassTrib}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="escopos">
            <th mat-header-cell *matHeaderCellDef>Escopos</th>
            <td mat-cell *matCellDef="let element">
                <div class="badges-row d-flex flex-wrap gap-1">
                    @for (escopo of element.escopos; track $index) {
                        <span class="status-badge badge-cinza">{{ getTipoEscopoLabel(escopo) }}</span>
                    }
                    @if (element.escopos.length === 0) {
                        <span class="text-secondary" style="font-size:0.82rem;">—</span>
                    }
                </div>
            </td>
        </ng-container>



        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
                @if (element.isAtivo) {
                <span class="status-badge badge-verde">Ativa</span>
                } @else {
                <span class="status-badge badge-vermelho">Inativa</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let element" class="text-center w-actions">
                <button mat-icon-button [matMenuTriggerFor]="menuAcoes" aria-label="Ações">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuAcoes="matMenu">
                    <button mat-menu-item (click)="editarRegra(element.idRegraTributaria)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                    <button mat-menu-item (click)="alternarStatus(element)">
                        <span class="material-symbols-outlined">{{ element.isAtivo ? 'toggle_off' : 'toggle_on' }}</span>
                        <span>{{ element.isAtivo ? 'Inativar' : 'Ativar' }}</span>
                    </button>
                    <button mat-menu-item (click)="confirmarExclusao(element)">
                        <span class="material-symbols-outlined">delete</span>
                        <span>Excluir</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>

    <!-- Cards mobile -->
    <div class="mobile-view">
        @for (item of _dataSource.data; track item.idRegraTributaria) {
        <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                    <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                        [checked]="selection.isSelected(item)">
                    </mat-checkbox>
                    <span class="text-bold">{{item.nome}}</span>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menuMob">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuMob="matMenu">
                    <button mat-menu-item (click)="editarRegra(item.idRegraTributaria)">Editar</button>
                    <button mat-menu-item (click)="alternarStatus(item)">{{ item.isAtivo ? 'Inativar' : 'Ativar' }}</button>
                    <button mat-menu-item (click)="confirmarExclusao(item)">Excluir</button>
                </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
                <p class="mb-1 d-flex flex-wrap gap-1 align-items-center">
                    <strong class="me-1">Modelos de Documento:</strong>
                    @for (mod of item.modelosDocumento; track $index) {
                        <span class="status-badge badge-laranja">{{ getNomeModeloDocumento(mod) }}</span>
                    }
                    @if (item.modelosDocumento.length === 0) {
                        <span class="text-secondary">—</span>
                    }
                </p>
                <p class="mb-1"><strong>CST IBS/CBS:</strong> <span class="status-badge badge-azul ms-1">{{item.cst}}</span></p>
                <p class="mb-1"><strong>Cód. Classificação Trib. IBS/CBS:</strong> <span class="status-badge badge-roxo ms-1">{{item.cclassTrib}}</span></p>
                <p class="mb-1 d-flex flex-wrap gap-1 align-items-center">
                    <strong class="me-1">Escopos:</strong>
                    @for (escopo of item.escopos; track $index) {
                        <span class="status-badge badge-cinza">{{ getTipoEscopoLabel(escopo) }}</span>
                    }
                    @if (item.escopos.length === 0) {
                        <span class="text-secondary">—</span>
                    }
                </p>
                <p class="mb-0">
                    <strong>Status:</strong>
                    @if (item.isAtivo) {
                    <span class="status-badge badge-verde ms-1">Ativa</span>
                    } @else {
                    <span class="status-badge badge-vermelho ms-1">Inativa</span>
                    }
                </p>
            </div>
        </div>
        }
    </div>

    <div class="col-12 text-center mt-4 mb-5">
        <button mat-button class="btn-ver-mais btn-spinner" [class.btn-loading]="_isLoading"
            [disabled]="_isLoading || _allData.length >= _totalRegistros"
            [attr.aria-label]="_isLoading ? 'Carregando mais registros' : 'Ver mais'"
            (click)="proximaPagina()">
            <span class="material-symbols-outlined">expand_more</span>
            Ver Mais
            @if (_isLoading) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
    </div>

    } @else {
    <app-empty-list
        [title]="'Nenhuma regra tributária encontrada'"
        [subTitle]="'Adicione uma nova regra tributária da reforma fiscal para começar'">
    </app-empty-list>
    }
</div>
